import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/auth-context';
import { api } from '../lib/api';
import { ErrorNote } from '../components/ui';

export function LoginPage() {
  const { signIn } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const [forgotSent, setForgotSent] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await signIn(email, password);
      navigate('/', { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Sign in failed');
    } finally {
      setBusy(false);
    }
  }

  async function forgot() {
    if (!email) { setError('Enter your email address first'); return; }
    await api.post('/auth/forgot-password', { email });
    setForgotSent(true);
  }

  return (
    <div className="flex min-h-screen items-center justify-center px-4">
      <div className="card w-full max-w-sm p-6">
        <h1 className="text-xl font-semibold">D2P Expenses</h1>
        <p className="mt-1 text-sm text-slate-500">Sign in to submit and review expense reports.</p>

        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <label className="label" htmlFor="email">Email</label>
            <input id="email" type="email" className="field" autoComplete="username"
                   inputMode="email" autoCapitalize="none" value={email}
                   onChange={(e) => setEmail(e.target.value)} required />
          </div>
          <div>
            <label className="label" htmlFor="password">Password</label>
            <input id="password" type="password" className="field" autoComplete="current-password"
                   value={password} onChange={(e) => setPassword(e.target.value)} required />
          </div>

          <ErrorNote>{error}</ErrorNote>
          {forgotSent ? (
            <p className="text-sm text-emerald-700">
              If that address has an account, a reset link is on its way.
            </p>
          ) : null}

          <button type="submit" className="btn-primary w-full" disabled={busy}>
            {busy ? 'Signing in…' : 'Sign in'}
          </button>
          <button type="button" onClick={() => void forgot()} className="w-full text-sm text-brand underline">
            Forgot your password?
          </button>
        </form>
      </div>
    </div>
  );
}
